export function OutlookIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24">
      <g clipPath="url(#clip0_4282_659975)">
        <path
          fill="#1976D2"
          d="M23.75 5.25h-10.5a.75.75 0 000 1.5h8.314l-4.608 3.584-3.304-2.102-.804 1.266 3.75 2.386a.746.746 0 00.863-.041L23 7.533v9.717h-9.75a.75.75 0 000 1.5h10.5a.75.75 0 00.75-.75V6a.75.75 0 00-.75-.75z"
        ></path>
        <path
          fill="#2196F3"
          d="M13.729.923a.737.737 0 00-.617-.159l-12 2.25a.748.748 0 00-.612.737v16.5c0 .36.256.67.612.736l12 2.25a.747.747 0 00.888-.736v-21a.748.748 0 00-.271-.578z"
        ></path>
        <path
          fill="#FAFAFA"
          d="M7.25 17.25c-2.067 0-3.75-2.018-3.75-4.5 0-2.48 1.683-4.5 3.75-4.5S11 10.27 11 12.75c0 2.482-1.683 4.5-3.75 4.5zm0-7.5c-1.24 0-2.25 1.346-2.25 3 0 1.655 1.01 3 2.25 3s2.25-1.345 2.25-3c0-1.654-1.01-3-2.25-3z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4282_659975">
          <path fill="#fff" d="M0 0H24V24H0z" transform="translate(.5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
